import {
    RescueServiceTask,
    rescueServiceUnitLabel,
} from 'aos-services/src/services/tasks/types/task/RescueServiceTask'
import { TaskTemplate } from 'aos-services/src/services/tasks/types/task/TaskTemplate'
import { Box } from 'aos-ui-universal'
import React from 'react'

import type { PropsListEntry } from '../PropsListEntry'

export const rescueServiceTaskPropertyList = (
    t: RescueServiceTask | TaskTemplate<RescueServiceTask>,
): PropsListEntry[] => [
    ['tasks.task-preview.rescue-service.task-type', t.taskType?.label],
    ['tasks.task-preview.rescue-service.address', t.address],
    ['tasks.task-preview.rescue-service.aircraft-registration', t.aircraftRegistration],
    [
        'tasks.task-preview.rescue-service.units',
        !!t.units?.length && (
            <Box>
                {t.units.length > 0
                    ? t.units.map((ch, index) => (
                          <Box key={index}>{rescueServiceUnitLabel(ch)}</Box>
                      ))
                    : '-'}
            </Box>
        ),
    ],
    ['tasks.task-preview.rescue-service.additional-unit', t.additionalUnits],
]
